/**
 * ЕДИНСТВЕННЫЙ источник клиентских URL. Строк с путями по коду быть не должно.
 *
 * ⚠️ Четыре адреса ниже — не свободный выбор, а ПАРА к серверу: SPA-страница и генератор
 * ссылки/редиректа на неё обязаны совпадать. Меняешь путь здесь — меняй и парную строку
 * сервера в ТОЙ ЖЕ правке, иначе письмо или возврат из шлюза придут на 404.
 *   /auth/verify?status=...   server/modules/auth/auth.recovery.controller.ts:25 (302-цель)
 *   /auth/reset?token=...     server/lib/mail/links.ts:35 (ссылка в письме сброса)
 *   /payment-result?status=...  server/modules/payments/payments.policy.ts:88 (цель редиректа шлюзов)
 *   /                    цель редиректа /go/:campaign (трекинг кампаний)
 *
 * Сами колбэки Idram/ARCA (/payment/checkData|success|fail|ccReturn) — НЕ маршруты SPA и
 * здесь не живут: они зарегистрированы у шлюзов и лежат под серверным префиксом /payment.
 *
 * ⚠️ Расхождения с таблицей transfers/prompt_07_web_pages.md (устарела, код — источник правды):
 *   - там `/reset/:token` сегментом пути; на деле токен приходит в query-строке;
 *   - там `/verified`; на деле бэкенд редиректит на `/verify`;
 *   - там `/payment/success` и `/payment/fail` как страницы SPA — таких страниц быть НЕ МОЖЕТ:
 *     `/payment` входит в RESERVED_PREFIXES (server/lib/http/reserved-paths.ts) и до
 *     spaFallback не доходит вовсе. Результат оплаты живёт на /account/payment/result.
 *
 * ⚠️ Ни один маршрут не может начинаться с /api, /payment, /public, /go или /.well-known — эти префиксы
 * сервер обрабатывает сам и SPA их никогда не увидит.
 */
export const ROUTES = {
  home: '/',
  /** Вход. Вся аутентификация — под /auth/*. */
  signin: '/auth/signin',
  /**
   * Регистрация.
   *
   * ⚠️ Отдельный адрес заведён редизайном (решение владельца): в макете вход и регистрация
   * — два разных экрана, а не один с переезжающей панелью. До волны 3 оба адреса рендерят
   * ту же страницу, отличаясь начальным режимом; после — это две страницы.
   *
   * Серверной пары у адреса нет: на него ведут только ссылки внутри SPA.
   */
  register: '/auth/register',
  /** Токен в query: /auth/reset?token=... */
  reset: '/auth/reset',
  /** Статус в query: /auth/verify?status=ok|already|expired|invalid */
  verify: '/auth/verify',
  support: '/support',
  legalUserAgreement: '/legal/user-agreement',
  legalPrivacyPolicy: '/legal/privacy-policy',
  /**
   * Инструкция по удалению аккаунта (требование Google Play).
   *
   * ⚠️ Адрес указан в консоли магазина и открывается проверяющим напрямую — менять его
   * так же нельзя, как платёжные колбэки: смена пути = отказ в публикации приложения,
   * о котором узнаешь из письма магазина, а не из тестов.
   *
   * ⚠️ Строка ДУБЛИРУЕТСЯ в server/lib/http/seo/seo.pages.ts (сервер не импортирует код
   * web/) и заморожена тестом tests/http/seo.test.ts, который читает этот файл текстом.
   */
  legalAccountDeletion: '/legal/account-deletion',
  /** Статус в query: /payment-result?status=success|pending|auth_pending|declined|failed */
  paymentResult: '/payment-result',
  /**
   * Админка (волна 08). Живёт в СВОЁМ пространстве токенов: вход сюда не делает человека
   * авторизованным в кабинете и наоборот (memory/admin-auth.md).
   *
   * ⚠️ `/admin` не входит в RESERVED_PREFIXES сервера (`/api`, `/payment`, `/public`, `/go`),
   * поэтому эти адреса доходят до SPA-fallback. Заводить админский адрес под зарезервированным
   * префиксом нельзя — маршрут просто никогда не сработает.
   */
  adminSignin: '/admin',
  adminDashboard: '/admin/dashboard',
  /** Аналитика (редизайн, артборд 6b). Второй пункт бокового меню — сразу после сводки. */
  adminAnalytics: '/admin/analytics',
  adminUsers: '/admin/users',
  adminTasks: '/admin/tasks',
  adminPriceCards: '/admin/price-cards',
  adminFinance: '/admin/finance',
  adminCampaigns: '/admin/campaigns',
  /** Заявки на удаление аккаунта (требование Google Play). В PHP механизма не было. */
  adminAccountDeletions: '/admin/account-deletions',
  adminAudit: '/admin/audit',
} as const;
